import { useState, useEffect } from "react";
import { buscarEmpreendimentosService } from "../../../services/buscarEmpreendimentosService";

export const useBuscarEmpreend = (isModalOpen: boolean) => {
  const [empreendimentos, setEmpreendimentos] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      if (!isModalOpen) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      try {
        const data = await buscarEmpreendimentosService();
        setEmpreendimentos(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erro ao buscar empreendimentos:", error);
        setEmpreendimentos([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, [isModalOpen]);

  return { empreendimentos, isLoading };
};
